import Header from '@editorjs/header'

export default class CustomHeader extends Header {
  static get sanitize() {
    return Object.assign(Header.sanitize, {
      tocText: false,
    })
  }

  constructor(args) {
    super(args)
    this.tocText = args.data.tocText || ''
  }

  renderSettings() {
    if (this.currentLevel.number != 2) {
      return super.renderSettings()
    }

    const tocTextInput = document.createElement('input')
    tocTextInput.value = this.tocText
    tocTextInput.classList.add('ce-popover-item-html__custom-text-input')
    tocTextInput.placeholder = '目次用の見出しテキスト'
    tocTextInput.addEventListener('change', event => {
      this.tocText = event.currentTarget.value
    })

    return [
      ...super.renderSettings(),
      { type: 'separator' },
      { type: 'html', element: tocTextInput },
    ]
  }

  save(toolsContent) {
    return Object.assign(super.save(toolsContent), {
      tocText: this.currentLevel.number == 2 ? this.tocText : '',
    })
  }
}
